export const state = {
  retryAt: null,
  maintenanceModeEnabled: false,
}
